module.exports = __webpack_public_path__ + "img/SEBRAE-branca.ddfef05e.png";